<template>
   <div class="page">
		<div class="list">
			<div class="mask">
					<item-good v-for="(item , index) of listData" :key="item.id" :datas="item" :idx="index" @pays="toDetail"></item-good>
			</div>
      <div class="downBox" v-if="loadBtn && !listData.length">
        您还不是{{titles}}用户，请
        <div class="btn"><a href="http://apk.91xyqp.cn/web-down/index.html">前往下载</a></div>
      </div>
		</div>
    <div id="downloadButton" class="return-top" v-if="listData.length && isIOS && !isYp"></div>
    <div class="return-top" @click="returnFn" v-if="listData.length && !isIOS && !isYp"><a href="http://apk.91xyqp.cn/web-down/index.html"></a></div>
    <van-popup v-model:show="show">
      <div class="pop-box">
				<div class="tit">购买成功!</div>
				<!-- <div class="tit">请前往闲逸查看</div> -->
				
				<div class="btns">
					<div class="btn" @click="closeFn">
						关闭
					</div>
					<!-- <div class="btn reapp" v-if="listData.length" id="downloadButton2">
						前往APP
					</div> -->
				</div>
			</div>
    </van-popup>
   </div>
</template>
<script>
import Vue from 'vue'
import itemGood from '@/components/itemGood'
import config from '@/config/index'

export default {
  data () {
    return {
      token : '',
      listData : [],
      returnApp : false,
      produtId : '',
      playerId : '',
      payBtn : true,
      imgList : [],
      msg : '',
      rechargeType : 0,
      extend : '',
      show : false,
      loadBtn : false,
      isIOS : false,
      isYp : config.isYp,
      titles : config.isYp ? '邀朋' : '闲逸',
      orderId : ''
    }
  },
  created () {
    console.log(this.$route.query)
    const produtId = this.$route.query.goodId||'';
    const type = this.$route.query.type||'';
    const playerId = this.$route.query.playerId || ''
    this.rechargeType = this.$route.query.rechargeType || 0;
    this.extend = this.$route.query.extend || '';
    this.orderId = this.$route.query.orderId || '';

    const u = navigator.userAgent;
    this.isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

    if(type){
      this.returnApp = true;
    }
    if(produtId){
      this.produtId = produtId;
    }
    if(playerId){
      this.playerId = playerId;
    }
    
    this.token = localStorage.getItem('token_key')
    console.log(this.token)
    
    if(produtId){
      this.pays(produtId)
      this.$toast.loading({
        forbidClick: true,
        message: '加载中',
        duration: 0
      })
    }else{
      this.getList()
    }
  },
  mounted () {
    if(this.isIOS){
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = '//web.cdn.openinstall.io/openinstall.js' ;//在线引用
      
      //初始化
      s.addEventListener('load',()=>{
        var data = OpenInstall.parseUrlParams();//解析获取参数
        new OpenInstall({
        appKey : "j7avzo",
        //channelCode : “xxx”,//渠道编号，可选
        //apkFileName : 'com.fm.openinstalldemo-v2.2.0.apk',//自定义下载时的apk包名
        preferWakeup:true, 
      
          //openinstall初始化完成的回调函数，可选
        onready : function() { 
          var m = this,
          button = document.getElementById("downloadButton")||null;
          m.schemeWakeup();//页面加载时拉起
          if(button){
            button.onclick = function() {
                    m.wakeupOrInstall();//下载或者拉起应用
                    return false;
            }
          } 
            
          }
        },data);
      
      },false)

      document.head.appendChild(s);
    }
	   

  },
  components: {
    itemGood
  },
  methods: {
    toDetail(item){
      console.log(item)
      let {id=''} = item;
      this.$router.push({
        path: '/detail',
        query: {
          id
        }
      })
    },
    async pays(e){
        console.log(e)

				if(this.payBtn){
					this.payBtn = false;
					let id = '';
          if(e.constructor  === Object){
            id = e.id;
          }else{
            id = e
          }
          let appid = localStorage.getItem('appId')
					let d = {
						productId : id,
						xyUserId : this.playerId,
						openId : this.token,
						attach : this.rechargeType,
						extend : this.extend,
            orderId : this.orderId,
            appid
					}
					let res = await this.$api.user.orderCreate(d)
          
					if(res.data.code == 200){
            let payInfo = res.data.data;
            if (typeof WeixinJSBridge === 'undefined') { // 微信浏览器内置对象。参考微信官方文档
            console.log('hhhhh')
              if (document.addEventListener) {
                document.addEventListener('WeixinJSBridgeReady', this.wxPay(payInfo), false)
              } else if (document.attachEvent) {
                document.attachEvent('WeixinJSBridgeReady', this.wxPay(payInfo))
                document.attachEvent('onWeixinJSBridgeReady', this.wxPay(payInfo))
              }
            } else {
              console.log('准备调用微信支付')
              this.wxPay(payInfo)
            }
					}else{
						this.$toast(res.data.message)
					}
          this.payBtn = true;
					if(this.produtId){
            this.$toast.loading({
              forbidClick: true,
              message: '加载中',
              duration: 0
            })
					}
					
				}
				
			},
			wxPay(data){
        console.log('调用微信支付WeixinJSBridge')
        WeixinJSBridge.invoke(
          'getBrandWCPayRequest', { // 下面参数内容都是后台返回的
            'appId': data.appId, // 公众号名称，由商户传入
            'timeStamp': String(data.timeStamp), // 时间戳
            'nonceStr': data.nonceStr, // 随机串
            'package': data.packageValue, // 预支付id
            'signType': data.signType, // 微信签名方式
            'paySign': data.paySign // 微信签名
          },
           (res) => {
          // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
            if (res.err_msg === 'get_brand_wcpay_request:ok') {
              this.openFn()
            } else {
              this.$toast('下单失败')
            }
            this.$toast.clear()
          }
        )
			},
			async getList(){
				let res = await this.$api.user.getList({
					openId : this.token
				})
        let data = res.data;
				this.listData = data;
        this.loadBtn = true;
				let imgList = [];
				data.forEach( (item)=>{
					imgList.push(item.productPic)
				})
				this.imgList = imgList;
			},
      closeFn(){
        this.show = false;
      },
      openFn(){
        this.show = true;
      },
      returnFn(){
        // var ifr = document.createElement('iframe');
        //   ifr.setAttribute('id', 'frm');
        // ifr.setAttribute('src',  'j7avzo://');
        // document.body.appendChild(ifr);
      }


      

  }
}
</script>
<style lang="less" scoped>
.page{
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
}
 .list{
		width: 100%;
		overflow: hidden;
		
		.mask{
			width: 380px;
			overflow: hidden;
			display: flex;
			flex-wrap: wrap;
		}
	}


  .pop-box{
		width: 240px;
		background: #fff;
		border-radius: 10px;
		padding: 12px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		.tit{
			font-size: 15px;
			color: #FE860C;
			line-height: 25px;
		}
		.btns{
			display: flex;
			align-items: center;
			justify-content: center;
			padding-top: 15px;
			.btn{
				width: 90px;
				height: 30px;
				display: flex;
				align-items: center;
				justify-content: center;
				background: linear-gradient(126deg, #FE860C 0%, #FC5F2C 100%);
				border-radius: 15px;
				font-size: 14px;
				color: #fff;
				position: relative;
				
				&.reapp{
					margin-left: 10px;
				}
				button{
					width: 100%;
					height: 100%;
					background: none;
					border: none;
					position: absolute;
					left: 0;
					top: 0;
					&::after{
						border: none;
					}
				}
			}
		}
	}


  .return-top{
		width: 45px;
		height: 45px;
		overflow: hidden;
		position: fixed;
		right: 12px;
		bottom: 75px;
    background: url('https://xianyihuyu.oss-cn-shenzhen.aliyuncs.com/tool/xy_app_return.png') no-repeat;
    background-size: 100% 100%;
    a{
      display: block;
      width: 100%;
      height: 100%;
    }
		.item{
			width: 45px;
			height: 45px;
			margin-bottom: 10px;
			image{
				width: 100%;
				height: 100%;
			}
			button{
			  width: 100%;
			  height: 100%;
			  background: none;
			  border: none;
			  &::after{
			  	border: none;
			  }
			}
		}
	}

  .downBox{
    text-align: center;
    padding-top: 100px;
    .btn{
      width: 200px;
      height: 50px;
      line-height: 50px;
      border-radius: 25px;
      background: #FE630C;
      color: #fff;
      font-size: 18px;
      text-align: center;
      margin: 20px auto 0;
      a{
        color: #fff;
      }
    }
  }

</style>
